import { Text, Primary13Regular, RedRed60 } from '@sequencehq/core-components'

type Props = {
  errors?: string[]
}

export const FieldValidationError = ({ errors }: Props) => {
  const message = errors?.[0]

  if (!message) {
    return null
  }

  return (
    <Text {...Primary13Regular} color={RedRed60}>
      {message}
    </Text>
  )
}
